import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import { DatePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import * as React from 'react';
import { FC } from 'react';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import { DatePicker } from 'components/facade/date-picker';
import {
  ClickEventTags,
  useLoadLoggerForDataDog,
} from 'hooks/use-data-dog-logger';
import { useTranslation } from 'hooks/use-translation';
import { DueDatePickerFooter } from './footer';
import { DateValueType } from './types';

type DueDateSinglePickerProps = Omit<
  DatePickerProps,
  'showToday' | 'bordered' | 'open' | 'placeholder' | 'suffixIcon'
> & {
  footerText?: string;
  endDateText?: string;
  canChooseStartDate: boolean;
  useAsStartDatePicker?: boolean;
  hideFooter?: boolean;
  hideClearDate?: boolean;
  isTodayDisabled?: boolean;
  isTomorrowDisabled?: boolean;
  clearDates(): void;
  modifyPickerType(): void;
  pickToday(): void;
  pickTomorrow(): void;
  onDone(): void;
  updateDates(date: DateValueType): void;
  dateRenderer?(
    currentDate: moment.Moment,
    today: moment.Moment,
  ): React.ReactNode;
};

export const DueDateSinglePicker: FC<
  React.PropsWithChildren<DueDateSinglePickerProps>
> = ({
  footerText,
  endDateText,
  canChooseStartDate,
  useAsStartDatePicker,
  hideFooter,
  hideClearDate,
  isTodayDisabled,
  isTomorrowDisabled,
  clearDates,
  modifyPickerType,
  pickToday,
  pickTomorrow,
  updateDates,
  onDone,
  dateRenderer,
  ...rest
}) => {
  const defaultText = useTranslation('due_date');
  const dueDateText = endDateText ?? defaultText;

  useLoadLoggerForDataDog([ClickEventTags.DueDatePickerPopup]);

  return (
    <DatePicker
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      autoFocus
      bordered={false}
      tabIndex={-1}
      showToday={false}
      open
      format={DATE_INPUT_DISPLAY_FORMAT}
      placeholder={dueDateText}
      suffixIcon={<EventSchedule16 />}
      onChange={updateDates}
      dateRender={dateRenderer}
      renderExtraFooter={() => (
        <>
          {!hideFooter ? (
            <DueDatePickerFooter
              footerText={footerText}
              canChooseStartDate={canChooseStartDate}
              hideClearDate={hideClearDate}
              type="single"
              onPickToday={pickToday}
              onPickTomorrow={pickTomorrow}
              onClear={clearDates}
              modifyPickerType={modifyPickerType}
              onDone={onDone}
              useAsStartDatePicker={useAsStartDatePicker}
              isTodayDisabled={isTodayDisabled}
              isTomorrowDisabled={isTomorrowDisabled}
            />
          ) : (
            <></>
          )}
        </>
      )}
    />
  );
};
